import React from "react";
import styled from "styled-components";

const Main = styled.main`
  width: 100%;
  padding-block: 20px;
  padding-inline: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const MainSubContainer = styled.div`
  width: 100%;
  background-color: aliceblue;
  display: flex;
  flex-direction: column;
  justify-content: left;
  align-items: center;
  padding-inline: 50px;
  padding-block: 30px;
`;
function Error() {
  return (
    <Main>
      <MainSubContainer className="space-y-10">
        <h1 className="font-bold">Oups...</h1>
        {/* <img
          src={PageNotFoundImage}
          alt="Page not found"
          className="!h-[300px]"
        /> */}
        <p className="font-bold">Il semblerait qu'il y ait un problème</p>
      </MainSubContainer>
    </Main>
  );
}

export default Error;
